import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import AdvisoryOverview from "@/pages/AdvisoryOverview";
import AdvisoryDetail from "@/pages/AdvisoryDetail";
import ExpertiseOverview from "@/pages/ExpertiseOverview";
import ExpertiseDetail from "@/pages/ExpertiseDetail";
import TechnicalHub from "@/pages/TechnicalHub";
import PUCentre from "@/pages/PUCentre";
import SiliconeCentre from "@/pages/SiliconeCentre";
import TechArticle from "@/pages/TechArticle";
import CalculatorsList from "@/pages/CalculatorsList";
import { CalculatorPage } from "@/components/calculators/CalculatorPage";
import TechnicalResources from "@/pages/TechnicalResources";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import MarketIntelligence from "@/pages/MarketIntelligence";
import ReportLanding from "@/pages/ReportLanding";
import GlobalSiliconeIndustry2026 from "@/pages/GlobalSiliconeIndustry2026";
import { REPORTS } from "@/data/reports";
import Resources from "@/pages/Resources";
import ResourceDetail from "@/pages/ResourceDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ServiceLanding from "@/pages/ServiceLanding";
import Legal from "@/pages/Legal";
import Search from "@/pages/Search";
import Login from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Admin (outside marketing layout) */}
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />

              <Route path="/advisory" element={<AdvisoryOverview />} />
              <Route path="/advisory/:slug" element={<AdvisoryDetail />} />

              <Route path="/expertise" element={<ExpertiseOverview />} />
              <Route path="/expertise/:slug" element={<ExpertiseDetail />} />

              <Route path="/polyurethane-consulting" element={<ServiceLanding />} />
              <Route path="/silicone-consulting" element={<ServiceLanding />} />
              <Route path="/technical-intelligence" element={<ServiceLanding />} />
              <Route path="/market-commercial-advisory" element={<ServiceLanding />} />
              <Route path="/supplier-distributor-advisory" element={<ServiceLanding />} />
              <Route path="/technical-hub" element={<TechnicalHub />} />
              <Route path="/technical-hub/polyurethane" element={<PUCentre />} />
              <Route path="/technical-hub/polyurethane/calculators" element={<CalculatorsList />} />
              <Route path="/technical-hub/polyurethane/:slug" element={<TechArticle kind="pu" />} />
              <Route path="/technical-hub/silicones" element={<SiliconeCentre />} />
              <Route path="/technical-hub/silicones/:slug" element={<TechArticle kind="sil" />} />
              <Route path="/technical-hub/calculators" element={<CalculatorsList />} />
              <Route path="/technical-hub/calculators/:slug" element={<CalculatorPage />} />
              <Route path="/technical-hub/resources" element={<TechnicalResources />} />

              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />

              <Route path="/market-intelligence" element={<MarketIntelligence />} />
              <Route path="/market-intelligence/global-silicone-industry-2026" element={<GlobalSiliconeIndustry2026 />} />
              {REPORTS.map((r) => (
                <Route key={r.slug} path={r.path} element={<ReportLanding slug={r.slug} />} />
              ))}

              <Route path="/resources" element={<Resources />} />
              <Route path="/resources/:slug" element={<ResourceDetail />} />

              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/search" element={<Search />} />

              <Route path="/privacy-policy" element={<Legal page="privacy-policy" />} />
              <Route path="/terms-of-use" element={<Legal page="terms-of-use" />} />
              <Route path="/technical-disclaimer" element={<Legal page="technical-disclaimer" />} />
              <Route path="/affiliate-disclosure" element={<Legal page="affiliate-disclosure" />} />

              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
